import { FormControlLabel, Switch } from '@mui/material';
import Button from '@shared/components/core/button/CoreButton';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import { SubSectionContent } from '@shared/components/core/layouts/CommonLayoutStyles';
import { useEmailPreferences } from '@shared/hooks/userSettings/useEmailPreferences';
import { useTranslation } from 'react-i18next';

export default function EmailPreferencesSection() {
    const { t } = useTranslation();
    const { isEmailOptIn, setIsEmailOptIn, handleSaveEmailPreferences } = useEmailPreferences();
    return (
        <>
            <SubSectionRow
                title={t('common:account.marketing.title')}
                description={t('common:account.marketing.description')}
            />
            <SubSectionContent>
                <FormControlLabel
                    value="start"
                    control={
                        <Switch
                            checked={isEmailOptIn}
                            onChange={() => {
                                setIsEmailOptIn(!isEmailOptIn);
                            }}
                        />
                    }
                    label={t('common:account.marketing.optIn')}
                    labelPlacement="end"
                />
                <Button onClick={handleSaveEmailPreferences}>{t('common:save')}</Button>
            </SubSectionContent>
        </>
    );
}
